import axios from "axios";
import { toast } from "react-toastify";
import {
  AdminLOADING,
  AdminERROR,
  AdminUsersListSUCCESS,
  AdminUserUpdateSUCCESS,
  AdminUserDeleteSUCCESS,
  AdminOrgsListSUCCESS,
} from "./Admin.types";
import toastOptions from "../toastOptions";
import { translate, getStoredLocale } from "../../i18n/translate";

const USERS_ENDPOINT = `${process.env.REACT_APP_APIURL}/v1/admin/users/`;
const ORGS_ENDPOINT = `${process.env.REACT_APP_APIURL}/v1/admin/organizations/`;

const authConfig = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const listAllUsersApi = (token) => async (dispatch) => {
  dispatch({ type: AdminLOADING });
  try {
    const { data } = await axios.get(USERS_ENDPOINT, authConfig(token));
    dispatch({ type: AdminUsersListSUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: AdminERROR });
  }
};

export const updateUserApi = (id, fields, token) => async (dispatch) => {
  dispatch({ type: AdminLOADING });
  try {
    const { data } = await axios.put(USERS_ENDPOINT + id, fields, authConfig(token));
    dispatch({ type: AdminUserUpdateSUCCESS, payload: data });
    toast.success(translate(getStoredLocale(), "toasts.userUpdated"), toastOptions);
    return data;
  } catch (e) {
    dispatch({ type: AdminERROR });
    throw e;
  }
};

export const deleteUserApi = (id, token) => async (dispatch) => {
  dispatch({ type: AdminLOADING });
  try {
    await axios.delete(USERS_ENDPOINT + id, authConfig(token));
    dispatch({ type: AdminUserDeleteSUCCESS, payload: id });
    toast.success(translate(getStoredLocale(), "toasts.userDeleted"), toastOptions);
  } catch (e) {
    dispatch({ type: AdminERROR });
    throw e;
  }
};

// disableMfaApi turns off every MFA factor on an account (see
// ai-instruct-68), for when a user is locked out of their authenticator or
// security key.
export const disableMfaApi = (id, token) => async (dispatch) => {
  dispatch({ type: AdminLOADING });
  try {
    const { data } = await axios.post(`${USERS_ENDPOINT}${id}/disable-mfa`, {}, authConfig(token));
    dispatch({ type: AdminUserUpdateSUCCESS, payload: data });
    toast.success(translate(getStoredLocale(), "toasts.mfaDisabled"), toastOptions);
    return data;
  } catch (e) {
    dispatch({ type: AdminERROR });
    throw e;
  }
};

export const listAllOrganizationsApi = (token) => async (dispatch) => {
  dispatch({ type: AdminLOADING });
  try {
    const { data } = await axios.get(ORGS_ENDPOINT, authConfig(token));
    dispatch({ type: AdminOrgsListSUCCESS, payload: data });
    return data;
  } catch (e) {
    dispatch({ type: AdminERROR });
  }
};
